import { FilterType } from "../../../types/filter";

export const filterTypesArray: FilterType[] = [
  FilterType.recyclingUnsuccessful,
  FilterType.recyclingModerate,
  FilterType.recyclingSuccessful,
];
